module.exports = __webpack_public_path__ + "img/principled.e182c2ef.svg";